import React, { useCallback, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  Space,
  Upload,
  Image,
  Row,
  Col,
  Popconfirm,
  InputNumber,
  Descriptions,
  Tag,
} from "antd";
import {
  InboxOutlined,
  FilePdfOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_DELETE_IMAGE_NEW,
  POST_INSERT_REJUDGE_REQUEST,
  POST_UPLOAD_IMAGE_NEW,
} from "../../../API/apiUrls";
import Compressor from "compressorjs";

const { TextArea } = Input;

const formatMoney = (v) =>
  v === null || v === undefined || v === ""
    ? "-"
    : Number(v).toLocaleString("th-TH");

const formatThaiDate = (v) =>
  v ? dayjs(v).add(543, "year").format("D MMM YY") : "-";

const ReBalanceFinance = ({ open, close, dataDefault, onSuccess }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // ✅ เพิ่ม State สำหรับจัดการรูปภาพ
  const [fileList, setFileList] = useState([]);
  const [allImg, setAllImg] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileListByContract, setFileListByContract] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  console.log("dataDefault", dataDefault);

  // ✅ ปิด Modal และ Reset
  const handleClose = useCallback(() => {
    form.resetFields();
    setFileList([]);
    close(false);
  }, [form, close]);

  // ✅ ส่งข้อมูล
  const sendStatus = async (data) => {
    try {
      const res = await axios.post(POST_INSERT_REJUDGE_REQUEST, data, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (res.status === 200) {
        return { success: true, status: res.status };
      } else {
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      return {
        success: false,
        error:
          error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล",
      };
    }
  };

  const handleUpLoadIMG = useCallback(async (resultImgs, menu, data) => {
    setLoading(true);
    const newFormData = new FormData();

    try {
      newFormData.append("id", data.id);
      newFormData.append("notis", menu);
      console.log("resultImgs", resultImgs);

      // ปรับให้รองรับทั้ง 2 format
      // 1. Format เดิม (มี originalIndex, imageCompressedFile)
      // 2. Format จาก Ant Design Upload (มี originFileObj)

      let filesToUpload = [];

      // เช็คว่าเป็น format ไหน
      const hasOriginalIndex = resultImgs.some(
        (img) => img.originalIndex !== undefined,
      );

      if (hasOriginalIndex) {
        // Format เดิม - sort ตาม originalIndex
        filesToUpload = resultImgs
          .filter((img) => img.originalIndex !== undefined)
          .sort((a, b) => {
            const typeDiff = (a.type || 0) - (b.type || 0);
            if (typeDiff !== 0) return typeDiff;
            return a.originalIndex - b.originalIndex;
          })
          .map((file, index) => ({
            file: file.imageCompressedFile,
            menuType: menu,
            imageType: 12,
          }));
      } else {
        // Format จาก Ant Design Upload
        filesToUpload = resultImgs
          .filter((img) => img.originFileObj)
          .map((file, index) => ({
            file: file.originFileObj,
            menuType: menu,
            imageType: 17, // default type = 1
          }));
      }

      console.log("filesToUpload", filesToUpload);

      if (filesToUpload.length === 0) {
        message.warning("ไม่พบไฟล์ที่ต้องอัปโหลด");
        return null;
      }

      for (const item of filesToUpload) {
        newFormData.append("file", item.file);
        newFormData.append("menuType", item.menuType);
        newFormData.append("imageType", item.imageType);
      }

      console.log("newFormData", newFormData);

      const response = await axios.post(POST_UPLOAD_IMAGE_NEW, newFormData, {
        headers: HEADERS_UPIMAGE,
      });

      if (response.status === 200) {
        message.success("บันทึกรูปสำเร็จ");
        return response.status;
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("บันทึกรูปไม่สำเร็จ");
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const onFinish = async (values) => {
    if (fileList.length < 1) {
      message.error("กรุณาเลือกไฟล์เพื่ออัปโหลด");
      return;
    }
    const postData = {
      receiveAmount: values.closeBalance,
      loanId: dataDefault?.loanId,
      mark: values.memo || null,
      userId: userId,
      rejudgeContno: values.rejudgeContno,
    };

    console.log("postData:", postData);
    console.log("fileList", fileList);

    try {
      setLoading(true);

      const result = await sendStatus(postData);

      if (!result.success) {
        throw new Error(result.error);
      }
      console.log("✅ ขั้นตอนที่ 1: บันทึกข้อมูลสำเร็จ");
      if (fileList && fileList.length > 0) {
        console.log(
          `📤 ขั้นตอนที่ 2: กำลังอัปโหลดรูปภาพ ${fileList.length} ไฟล์...`,
        );

        const uploadData = {
          id: dataDefault?.loanId,
        };

        const uploadResult = await handleUpLoadIMG(fileList, 10, uploadData);

        if (uploadResult === 200) {
          console.log("✅ ขั้นตอนที่ 2: อัปโหลดรูปภาพสำเร็จ");
        } else {
          console.error("❌ อัปโหลดรูปภาพล้มเหลว:", uploadResult.error);
          message.warning({
            content: "บันทึกข้อมูลสำเร็จ แต่อัปโหลดรูปภาพล้มเหลว",
            duration: 4,
          });
        }
      }
      message.success("อัพเดทข้อมูลสำเร็จ");

      setTimeout(() => {
        handleClose();
        onSuccess?.();
      }, 500);
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error);
      message.error(error.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบ");
  };

  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ลบรูป (รับ array)
  const handleDeleteIMG = async (images) => {
    if (!images || images.length === 0) return;

    setLoading(true);
    try {
      // ✅ แก้ axios config - headers ต้องอยู่ใน object เดียวกับ data
      const res = await axios.delete(POST_DELETE_IMAGE_NEW, {
        data: images,
        headers: HEADERS_UPIMAGE,
      });

      if (res.status === 200) {
        const selectedPaths = new Set(images.map((img) => img.path));
        setFileListByContract((prev) =>
          prev.filter((img) => !selectedPaths.has(img.path)),
        );
        message.success("ลบรูปสำเร็จ");
      }
    } catch (err) {
      message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
      console.error("err", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ ลบรูปเดียว - ส่งเป็น array
  const handleDeleteSingleImage = async (image) => {
    await handleDeleteIMG([image]);
  };

  // ✅ Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // ✅ Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => {
      if (f.type === "application/pdf" || f.name.endsWith(".pdf")) {
        // Custom icon logic ถ้าต้องการ
      }
      return f;
    });

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // ✅ Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // ✅ Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) => beforeUpts(file, 17), //17 = ขอยอดปิด รีไฟแนนซ์
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  return (
    <Modal
      title="อัพเดทข้อมูลรีไฟแนนซ์"
      open={open}
      onCancel={handleClose}
      width={850}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังบันทึก...">
        <Card>
          <Descriptions
            bordered
            size="small"
            column={2}
            style={{ marginBottom: 20 }}
          >
            <Descriptions.Item label="เลขสัญญา">
              {dataDefault?.newContno ?? "-"}
              {dataDefault?.CONTNO &&
                dataDefault.CONTNO !== dataDefault.newContno && (
                  <span style={{ fontSize: 12, color: "#999" }}>
                    {" "}
                    (เดิม {dataDefault.CONTNO})
                  </span>
                )}
            </Descriptions.Item>
            <Descriptions.Item label="ชื่อ-นามสกุล">
              {dataDefault?.fullName ?? "-"}
              <span style={{ fontSize: 12, color: "#999" }}>
                {" "}
                ({dataDefault?.CUSCOD ?? "-"})
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="ยอดตามคำพิพากษา">
              {formatMoney(dataDefault?.totalJugde)} บาท
            </Descriptions.Item>
            <Descriptions.Item label="ยอดหนี้คงเหลือ">
              {formatMoney(dataDefault?.balance)} บาท
            </Descriptions.Item>
            <Descriptions.Item label="เลขคดีดำ">
              {dataDefault?.blackCaseNumber ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="เลขคดีแดง">
              {dataDefault?.redCaseNumber ?? "-"}
            </Descriptions.Item>
            <Descriptions.Item label="วันที่พิพากษา" span={2}>
              {formatThaiDate(dataDefault?.judgeDate)}
            </Descriptions.Item>
          </Descriptions>

          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 14 }}
            layout="horizontal"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label="สัญญาใหม่"
              name="rejudgeContno"
              rules={[{ required: true, message: "กรุณากรอกยอดปิด" }]}
            >
              <Input
                size="large"
                placeholder="กรอกเลขสัญญาใหม่"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="ยอดปิด"
              name="closeBalance"
              rules={[{ required: true, message: "กรุณากรอกยอดปิด" }]}
            >
              <InputNumber
                size="large"
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                placeholder="จำนวนยอดปิดที่เฮียกำหนด"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              label="เอกสารขอรีไฟแนนซ์"
              name="file"
              rules={[{ required: true, message: "กรุณาอัปโหลดไฟล์ !" }]}
            >
              <Dragger
                {...uploadProps}
                style={{
                  padding: "20px",
                  background: "#fafafa",
                  borderRadius: 8,
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ color: "#1890ff", fontSize: 48 }} />
                </p>
                <p className="ant-upload-text" style={{ fontSize: 16 }}>
                  กรุณาคลิกหรือลากเพื่อเลือกไฟล์
                </p>
                {/* <p className="ant-upload-hint" style={{ color: "#999" }}>
                       รองรับการอัปโหลดแบบเดี่ยวหรือแบบกลุ่ม (ไฟล์ละไม่เกิน 5 MB)
                     </p> */}
              </Dragger>
            </Form.Item>
            {(() => {
              const filteredFiles =
                fileListByContract?.filter((e) => e.imageType === 12) || [];
              if (filteredFiles.length === 0) return null;

              return (
                <Form.Item label="ไฟล์คำฟ้อง" name="file">
                  <Spin spinning={loading} size="large" tip="Loading...">
                    <Row gutter={[8, 8]} justify="center">
                      {filteredFiles.map((e, index) => {
                        const isPdf = e.path?.toLowerCase().endsWith(".pdf");
                        const isSelected = selectedImages?.some(
                          (img) => img.path === e.path,
                        );
                        const label = "ใบขออนุมัติรีไฟแนนซ์";

                        return (
                          <Col
                            key={e.path || index}
                            xs={12}
                            sm={8}
                            md={6}
                            lg={6}
                            xl={6}
                          >
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              {/* ปุ่มลบรูปเดียว */}
                              <Popconfirm
                                title="ยืนยันการลบ"
                                description="ต้องการลบไฟล์นี้?"
                                onConfirm={() => handleDeleteSingleImage(e)}
                                okText="ลบ"
                                cancelText="ยกเลิก"
                                okButtonProps={{ danger: true }}
                              >
                                <Button
                                  type="primary"
                                  danger
                                  size="small"
                                  icon={<DeleteOutlined />}
                                  style={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    zIndex: 10,
                                  }}
                                />
                              </Popconfirm>

                              <Card
                                hoverable
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  padding: "8px",
                                  border: isSelected
                                    ? "2px solid #1890ff"
                                    : undefined,
                                }}
                              >
                                {isPdf ? (
                                  <div
                                    onClick={() =>
                                      window.open(
                                        `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                        "_blank",
                                      )
                                    }
                                    style={{
                                      height: "120px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      backgroundColor: "#f0f0f0",
                                      borderRadius: "8px",
                                      border: "1px solid #d9d9d9",
                                    }}
                                  >
                                    <FilePdfOutlined
                                      style={{
                                        fontSize: "40px",
                                        color: "#ff4d4f",
                                      }}
                                    />
                                    <span
                                      style={{
                                        marginTop: "8px",
                                        fontSize: "12px",
                                        color: "#666",
                                      }}
                                    >
                                      คลิกเพื่อเปิด PDF
                                    </span>
                                  </div>
                                ) : (
                                  <>
                                    <Image
                                      width="100%"
                                      height="120px"
                                      src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                      alt={`รูปภาพ ${index}`}
                                      style={{
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                      preview={{
                                        src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                      }}
                                    />

                                    <Tag
                                      color="green"
                                      style={{
                                        fontSize: 11,
                                        borderRadius: 10,
                                        marginTop: "10px",
                                      }}
                                    >
                                      {label}
                                    </Tag>
                                  </>
                                )}
                              </Card>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </Spin>
                </Form.Item>
              );
            })()}

            <Form.Item label="หมายเหตุ" name="memo">
              <TextArea rows={4} placeholder="ระบุหมายเหตุ (ถ้ามี)" />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 6, span: 14 }}>
              <Space size="middle">
                <Button onClick={handleClose} danger>
                  ยกเลิก
                </Button>
                <Button type="primary" htmlType="submit">
                  บันทึก
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </Modal>
  );
};

export default ReBalanceFinance;
